import { features } from "@/mocks/home";

export default function FeatureGrid() {
  return (
    <section id="feature" className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">深度专题</p>
            <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              标题先说结论，专题再把证据补上
            </h2>
            <p className="mt-2 font-body text-sm text-foreground-600">
              不靠耸动标题赚流量，靠一份份能对上的材料把深挖专题做厚。
            </p>
          </div>
          <a
            href="#resource"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap font-label text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            全部专题
            <i className="ri-arrow-right-line text-base" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <a
              key={f.tag}
              href="#resource"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={f.image}
                  alt={f.title}
                  title={`${f.title} - 免费黑料独家爆料`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 font-label text-[11px] font-semibold text-background-50">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {f.title}
                </h3>
                <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="font-label text-xs text-foreground-400">{f.meta}</span>
                  <i className="ri-arrow-right-line text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}